import { render, staticRenderFns } from "./clientVisitRecords.vue?vue&type=template&id=3b35eb6d&scoped=true"
import script from "./clientVisitRecords.vue?vue&type=script&lang=js"
export * from "./clientVisitRecords.vue?vue&type=script&lang=js"
import style0 from "./clientVisitRecords.vue?vue&type=style&index=0&id=3b35eb6d&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b35eb6d",
  null
  
)

export default component.exports